import { createFileRoute } from '@tanstack/react-router';

import VariablePage from '../../components/pages/VariablePage';

export const Route = createFileRoute('/variables/')({
  component: () => <VariablePage />,
});
